import { createAction } from "redux-actions";
import { api } from "../../services";
import endPoints from "../../services/apiEndPoints";
import { PROFILE_INFO_REQUEST, PROFILE_INFO_SUCCESS } from "./types";
import { updateUserAuth } from "../auth/actions";
const profileInfoRequest = createAction(PROFILE_INFO_REQUEST);
const profileInfoSuccess = createAction(PROFILE_INFO_SUCCESS);

export const getProfileData = () => async (dispatch) => {
  dispatch(profileInfoRequest());
  return api
    .get(`${endPoints.GET_PROFILE_DATA}`)
    .then((res) => {
      dispatch(updateUserAuth({ user: res.data }))
      dispatch(profileInfoSuccess(res.data));
      return res;
    })
    .catch((error) => {
      throw error;
    });
};
